module.exports = __webpack_public_path__ + "static/media/Chat.b0f30141.svg";